import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=727a2b48&scoped=true&"
import script from "./TagsInput.vue?vue&type=script&lang=js&"
export * from "./TagsInput.vue?vue&type=script&lang=js&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=727a2b48&lang=scss&scoped=true&"
import style1 from "./TagsInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727a2b48",
  null
  
)

export default component.exports